import React, {Component} from "react";
import {connect} from "react-redux";

import * as actions from "../../actions/navigationActions";

import SimpleFooterComponent from "../../components/global/SimpleFooter";

class SimpleFooter extends Component {
    showNotificationPanel = () => {
        this.props.dispatchShowNotificationPanelAction(!this.props.activeNotificationPanel);
    };

    render() {
        return (
            <SimpleFooterComponent
                initialized={this.props.initialized}
                connected={this.props.connected}
                active={this.props.activeNotificationPanel}
                virtualKeyboardSupport={this.props.virtualKeyboardSupport}
                clientVersion={this.props.clientVersion}
                buildVersion={this.props.buildVersion}
                softwareRevision={this.props.softwareRevision}
                activeDatabase={this.props.activeDatabase}
                flashMessages={this.props.flashMessages}
                flashMessagesStatus={this.props.flashMessagesStatus}
                showNotificationPanel={this.showNotificationPanel}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        initialized: store.global.initialized,
        connected: store.server.connected,
        clientVersion: store.module.softwareVersion,
        buildVersion: store.module.buildVersion,
        softwareRevision: store.module.softwareRevision,
        activeDatabase: store.server.activeDatabase,
        activeNotificationPanel: store.navigation.activeNotificationPanel,
        flashMessages: store.navigation.flashMessages,
        flashMessagesStatus: store.navigation.flashMessagesStatus
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchShowNotificationPanelAction: (activeNotificationPanel) => {
            dispatch(actions.setNotificationPanel(activeNotificationPanel));
        }
    };
};

export default SimpleFooter = connect(mapStoreToProps, mapDispatchToProps)(SimpleFooter);
